import { useEffect } from 'react'

const useSimulatedDonation = ({ session, setDonation, partnerItem }) => {
  useEffect(() => {
    if (!session.staff) return

    const handleMessage = e => {
      if (e.origin != location.origin) return
      switch (e.data) {
      case 'simulateDonation':
        return setDonation({
          token: btoa(Math.random().toString().slice(2, 14)),
          paymentOption: 'credit_card',
          simulated: true,
          partnerItem,
        })
      }
    }

    addEventListener('message', handleMessage)
    return () => removeEventListener('message', handleMessage)
  }, [])
}

export default useSimulatedDonation
